import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { 
	CSidebar,
	CSidebarBrand,
	CSidebarNav,
	CSidebarToggler,
	CImage
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { ContSidebarNav } from './ContSidebarNav'

// sidebar nav config
//import navigation from '../_nav'

const pjson = require('../../package.json');
const ContSidebar = () => {
	const uDispatch 	= useDispatch()
	const uUnfoldable 	= useSelector((state) => state.sidebarUnfoldable);
	const uSidebarshow	= useSelector((state) => state.sidebarShow)
	const uListnav 		= useSelector((state) => state.listNav)

	//console.log("(ContSidebar) uListnav => "+JSON.stringify(uListnav));
	//console.log("(ContSidebar) navigation => "+JSON.stringify(navigation));
	return (
		<CSidebar position="fixed" unfoldable={uUnfoldable}
			visible={uSidebarshow}
			onVisibleChange={(visible) => {
				uDispatch({ type: 'set', sidebarShow: visible })
			}}
			className="bg-secondary"
			id="idsidebarmain">
		<CSidebarBrand className="d-none d-md-flex">
			<span className="sidebar-brand-narrow">
			<CImage src="/images/logobw40.png"  height={33}/>
			</span>

			<span className="sidebar-brand-full classfontbrand fs-3 text-white" style={{}}>
			{(()=>{
				const vNameArr = pjson.name.split("tor");

				return (
				<>
				{vNameArr[0]}t
				<CImage src={"/images/logo192.png"} height={30}/>
				r{vNameArr[1]}
				</>
				)
			})()}
			</span>
		</CSidebarBrand>

		<CSidebarNav>
			<ContSidebarNav items={uListnav} />
		</CSidebarNav>

		<CSidebarToggler className="d-none d-lg-flex"
			onClick={() => uDispatch({ type: 'set', sidebarUnfoldable: !uUnfoldable })}/>
		</CSidebar>
	)
}

export default React.memo(ContSidebar)